export enum Locales {
  EN = "en",
  RU = "ru",
}

export const LOCALES = [
  { value: Locales.EN, caption: "English" },
  { value: Locales.RU, caption: "Русский" },
];
